<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="guardar()"
    >
      <v-card-title>
        DUPLICACIÓN DE OTROS INGRESOS
        <v-spacer/>
        <v-btn
            icon
            @click="$emit('close')"
        >
          X
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="7">
            <v-text-field
                v-model="numeroFactura"
                label="Número de factura *"
                outlined
                autofocus
                maxlength="10"
                :rules="[v => !!v || 'Número de factura es requerida']"
                @keypress="patterns.onlyNumber($event)"
            />
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field
                v-model="fecha"
                label="Fecha *"
                type="date"
                outlined
                maxlength="8"
                :rules="[v => !!v || 'Fecha es requerida']"
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-select
                label="Motivo *"
                v-model="motivo"
                :items="motivos"
                item-value="id"
                item-text="descripcion"
                outlined
                return-object
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-footer>
        <v-spacer/>
        <v-btn
            color="primary"
            type="submit"
            :loading="loading"
        >
          Duplicar factura
        </v-btn>
      </v-footer>
    </v-form>
    <div id="myElement"></div>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {duplicacionStore} from "@/store/duplicacionStore";
import {Duplicacion} from "@/models/Duplicacion";
import {Pattern} from "@/addons/Pattern";
import {DateTime} from "luxon";
import {DuplicacionService} from "@/services/DuplicacionService";
import {recaudacionStore} from "@/store/recaudacionStore";
import { PrintOtroIngreso } from "@/addons/PrintOtroIngreso";

@Component({
  name: "DuplicacionOtroIngreso",
})

export default class DuplicacionOtroIngreso extends Vue {
  private patterns = Pattern;
  private duplicacionStore = duplicacionStore();
  private recaudacionStore = recaudacionStore();
  private duplicacionService = DuplicacionService.getInstance();

  numeroFactura = null;
  fecha = DateTime.now().toFormat("yyyy-MM-dd");
  motivo = {
    "cod": "1",
    "descripcion": "POR DESPERFECTO"
  };

  valid = true;
  $refs!: {
    form: HTMLFormElement
  };

  get loading(): boolean {
    return this.duplicacionStore.loading;
  }

  get duplicacion(): Duplicacion {
    return this.duplicacionStore.duplicacion;
  }

  get motivos(): any[] {
    return this.duplicacionStore.motivos;
  }

  mounted() {
    this.duplicacionService.getMotivosDuplicacion();
  }

  guardar() {
    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      numeroFactura: this.numeroFactura,
      fecha: this.fecha,
      motivo: this.motivo
    }

    this.duplicacionService.duplicacionOtroServicio(data).then(res => {
      if (res) {
        this.resetFields();
        let fac = this.recaudacionStore.facturaPrintOtroIngreso;
        this.imprimir(fac);
      }
    });
  }

  public imprimir(fac: any) {
    const print = new PrintOtroIngreso();
    print.imprimir(fac,true);
  }

  private resetFields() {
    this.numeroFactura = null;
    this.fecha = DateTime.now().toFormat("yyyy-MM-dd");
    this.motivo = {
      "cod": "1",
      "descripcion": "POR DESPERFECTO"
    };
  }
}
</script>

<style scoped>

</style>